import { CSSProperties, FC } from "react";
import { Input, InputValidationType } from "boomform";
import ReactTooltip from "react-tooltip";
import cx from "classnames";

import { BoomFormInputType } from "./../../index-types";
import Icon, { IconTypes } from "./../Icon";

import styles from "./styles.module.scss";

export enum InputType {
    TEXT = "text",
    EMAIL = "email",
    DATE = "date",
    PASSWORD = "password",
}

interface IProps {
    id: string;
    initialValue?: string;
    value?: string;
    inputClassName?: string;
    label?: string;
    labelClassName?: string;
    type?: InputType;
    placeholder?: string;
    validation?: InputValidationType;
    disabled?: boolean;
    maxDate?: string;
    minDate?: string;
    style?: CSSProperties;
}

const LibInput: FC<IProps> = ({
    id,
    initialValue,
    inputClassName,
    label,
    labelClassName,
    type = InputType.TEXT,
    placeholder,
    validation,
    disabled = false,
    maxDate,
    minDate,
    style,
}) => {
    return (
        <div
            className={cx(styles.inputBox, {
                [styles.disabled]: disabled,
            })}
        >
            {label && (
                <label htmlFor={id} className={cx(styles.label, { [labelClassName!]: labelClassName })}>
                    {label}
                </label>
            )}

            <Input
                required={true}
                id={id}
                className={inputClassName}
                initial={initialValue}
                placeholder={placeholder}
                type={type as BoomFormInputType}
                validation={validation}
                disabled={disabled}
                max={maxDate}
                min={minDate}
                style={style}
                onClick={e => {
                    const clickX = e.clientX;
                    const clickY = e.clientY;
                    const element = e.target as HTMLInputElement;
                    const elementParameters = element.getBoundingClientRect();
                    const { x, y, width, height } = elementParameters;

                    if (
                        clickX > x + width - 36 &&
                        clickX < x + width - 12 &&
                        clickY > y + height / 2 - 12 &&
                        clickY < y + height / 2 + 12
                    ) {
                        ReactTooltip.hide();
                    }
                }}
            />

            {type === InputType.DATE && <Icon type={IconTypes.DATE_MOUNTH} size={24} />}
        </div>
    );
};

export default LibInput;
